export default {"src":"/_next/static/media/connected-icon.957e81ad.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};